/*
Common messages (used every year)
*/
import en from './en.yaml'
import zh from './zh.yaml'
import ja from './ja.yaml'
import fr from './fr.yaml'
import es from './es.yaml'
import id from './id.yaml'

export default {
  en,
  zh,
  ja,
  fr,
  es,
  id
}



// WEBPACK FOOTER //
// ./i18n/common/index.js